<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ApplyLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '裁判员申报'
            },
            {
              key: '2',
              title: '裁判员管理'
            },
            {
              key: '3',
              title: '教练员申报'
            },
            {
              key: '4',
              title: '教练员管理'
            }, 
            {
              key: '5',
              title: '批量等级查询'
            },

 
          ],
          active: () => {
            switch (this.$route.path) {
              case '/huiyi/ShengCaipanManage':
                return '1'
              case '/huiyi/ShengCaipanList':
                return '2'
              case '/huiyi/ShengJiaolianManage':
                return '3'
              case '/huiyi/ShengJiaolianList':
                return '4'
              case '/huiyi/CpJlGrade':
                return '5'


              case '/huiyi/GuoCaipanManage':
                return '5'
              case '/huiyi/GuoCaipanList':
                return '6'
              case '/huiyi/GuoJiaolianManage':
                return '7'
              case '/huiyi/GuoJiaolianList':
                return '8'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/huiyi/ShengCaipanManage')
                break
              case '2':
                this.$router.push('/huiyi/ShengCaipanList')
                break
              case '3':
                this.$router.push('/huiyi/ShengJiaolianManage')
                break
              case '4':
                this.$router.push('/huiyi/ShengJiaolianList')
                break

              case '5':
                this.$router.push('/huiyi/CpJlGrade')
                break

              // case '5':
              //   this.$router.push('/huiyi/GuoCaipanManage')
              //   break
              case '6':
                this.$router.push('/huiyi/GuoCaipanList')
                break
              case '7':
                this.$router.push('/huiyi/GuoJiaolianManage')
                break
              case '8':
                this.$router.push('/huiyi/GuoJiaolianList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>